import { DateRangePicker } from 'react-dates';
import '../../guideBookingTab.css';
import { ReactComponent as DateCalendar } from '../../../../../assets/icons/trvto_dateCalendar.svg';
import { ReactComponent as Close } from '../../../../../assets/icons/trvto_closeWhite.svg';
import { SingleDatePicker } from 'react-dates';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import handleChange from '../../../../../utils/handleChange';
import NoPeopleSelect from '../../../../activityDetails/activityBookingTab/activityBookingTabFun/bookingTab/NoPeopleSelect';
import PlaceSelection from './PlaceSelection';

export const GuideDataBookingTab = ({
    booking,
    setBooking,
    confirmedBookingData,
    numPeople,
    time,
    languages,
    meetupLocation,
    price,
    packData
}) => {
    const [focusedInput, setFocusedInput] = useState(null);
    const isMobile = window.innerWidth < 768;
    const [selectedPlaceIndex, setSelectedPlaceIndex] = useState('');
    const calendarIcon = (
        <span role='img' aria-label='calendar' className='calendar-icon'>
            <DateCalendar />
        </span>
    );

    const [showSelector, setShowSelector] = useState(false);

    useEffect(() => {
        if (showSelector) {
            document.body.classList.add('modalOpen');
        } else {
            document.body.classList.remove('modalOpen');
        }

        return () => {
            document.body.classList.remove('modalOpen');
        };
    }, [showSelector]);

    return (
        <div className=''>
            <div className='dropdownDiv'>
                <label className='tripBookDatalabelFirst'>No. of People</label>
                <select
                    value={booking.people}
                    name='people'
                    onChange={(e) => handleChange(e, setBooking)}
                    required={true}
                    className='dropdownSelect'
                    disabled={confirmedBookingData?.userDetails.length}
                >
                    {numPeople.map(function (val, typeIndex) {
                        return (
                            <option key={typeIndex} value={val}>
                                {val}
                            </option>
                        );
                    })}
                </select>
            </div>

            <div className='dropdownDiv guideInput'>
                <label className='tripBookDatalabelFirst'>Select Place</label>
                <div
                    onClick={confirmedBookingData ? undefined : () => setShowSelector(true)}
                    className='dropdownSelect'
                    style={{
                        fontSize: '13px',
                        padding: '10px',
                        color: confirmedBookingData ? '#aaa' : 'grey',
                        cursor: confirmedBookingData ? 'not-allowed' : 'pointer'
                    }}
                >
                    {booking?.place?.name || 'Select Place'}
                </div>
            </div>
            {showSelector &&
                createPortal(
                    <div className='peopleOverlay' onClick={() => setShowSelector(false)}>
                        <Close width={30} height={30} style={{ cursor: 'pointer' }} />

                        <div className='peopleSheet' onClick={(e) => e.stopPropagation()}>
                            <PlaceSelection
                                data={price}
                                setShowSelector={setShowSelector}
                                booking={booking}
                                setBooking={setBooking}
                                packData={packData}
                            />
                        </div>
                    </div>,
                    document.body
                )}
            <div className='dropdownDiv guideInput'>
                <label className='tripBookDatalabelFirst'>Select Date</label>
                <SingleDatePicker
                    withPortal={isMobile}
                    date={booking.date ? moment(booking.date) : null}
                    onDateChange={(date) => {
                        if (!date) return;

                        setBooking((prev) => ({
                            ...prev,
                            date: date.toISOString(),
                            timeIndex: '',
                            timeSlots: '',
                            slotId: ''
                        }));

                        setFocusedInput(false);
                    }}
                    focused={focusedInput}
                    onFocusChange={({ focused }) => setFocusedInput(focused)}
                    displayFormat='DD-MM-YYYY'
                    numberOfMonths={1}
                    isOutsideRange={(day) => day.isBefore(moment().startOf('day'))}
                    showDefaultInputIcon
                    readOnly
                />
            </div>
            {booking?.date && (
                <div className='dropdownDiv guideInput'>
                    <label className='tripBookDatalabelFirst'>Select Time</label>

                    <select
                        value={booking.timeIndex ?? ''}
                        name='timeSlots'
                        onChange={(e) => {
                            const index = e.target.value;

                            if (index === '') return;

                            const selectedSlot = time[index];

                            setBooking((prev) => ({
                                ...prev,
                                timeIndex: index,
                                timeSlots: {
                                    startTime: selectedSlot.startTime,
                                    endTime: selectedSlot.endTime
                                },
                                slotId: selectedSlot._id
                            }));
                        }}
                        required={true}
                        className='dropdownSelect'
                    >
                        {time.length === 0 && booking.date ? (
                            <option value=''>No time slots available</option>
                        ) : (
                            <>
                                <option value=''>Select Time</option>

                                {time.map((val, index) => (
                                    <option key={index} value={index}>
                                        {`${val.startTime} - ${val.endTime}`}
                                    </option>
                                ))}
                            </>
                        )}
                    </select>
                </div>
            )}
            <div className='dropdownDiv guideInput'>
                <label className='tripBookDatalabelFirst'>Select Language</label>
                <select
                    value={booking.language}
                    name='language'
                    onChange={(e) => handleChange(e, setBooking)}
                    required={true}
                    className='dropdownSelect'
                    disabled={confirmedBookingData?.language}
                >
                    <option value='' disabled>
                        Select Language
                    </option>
                    {languages.map(function (val, typeIndex) {
                        return (
                            <option key={typeIndex} value={val}>
                                {val}
                            </option>
                        );
                    })}
                </select>
            </div>
            <div className='dropdownDiv guideInput'>
                <label className='tripBookDatalabelFirst'>Meetup Location</label>

                <select
                    value={meetupLocation.findIndex((val) => val.name === booking.meetupLocation?.name)}
                    onChange={(e) => {
                        const index = e.target.value;

                        if (index === '') return;

                        const selectedLocation = meetupLocation[index];

                        setBooking((prev) => ({
                            ...prev,
                            meetupLocation: {
                                name: selectedLocation.name,
                                location: selectedLocation.location
                            }
                        }));
                    }}
                    required={true}
                    className='dropdownSelect'
                    disabled={confirmedBookingData?.meetupLocation}
                >
                    <option value=''>Select Meetup Location</option>

                    {meetupLocation.map((val, index) => (
                        <option key={index} value={index}>
                            {val.name}
                        </option>
                    ))}
                </select>
            </div>

            {/* <div className='dropdownDiv'>
                <div className='dropdownLabelText'>
                    <label className='dropdownlabel'>Start City</label>
                    <Tooltip content='Select the city from which your trip will be initiated' position='top'>
                        <span className='eyeIcon'>
                            <InfoI color='blue' width={15} height={15} />
                        </span>
                    </Tooltip>
                </div>
                <select
                    value={customBooking.startCity}
                    name='startCity'
                    onChange={(e) => handlestartCity(e, setCustomBooking, startCity.current, setIndex)}
                    required={true}
                    className='dropdownSelect'
                    disabled={confirmedBookingData?.startCity}
                >
                    <option value='-1'>Select</option>
                    {startCity.current.map(function (val, typeIndex) {
                        return (
                            <option key={typeIndex} value={val}>
                                {val}
                            </option>
                        );
                    })}
                </select>
            </div>
            <Dropdown
                label='Pickup Location'
                name='pickupLocation'
                options={optionsForMeetUpLocation}
                value={customBooking?.pickupLocation || customBooking?.pickupLocation}
                req={true}
                setFormData={setCustomBooking}
                disabled={
                    !customBooking?.startCity ||
                    (!confirmedBookingData?.isTripMoreThanOneDays &&
                        (confirmedBookingData?.pickupLocation || confirmedBookingData?.meetupPoint))
                }
                infoIcon={true}
                infoContent={'Select the point from which your trip will be initiated'}
            /> */}
            {/* {packData?.price[0]?.customPrice?.groupPrice > 0 && (
                <>
                    <div className='dropdownLabelText'>
                        <label className='dropdownlabel'>Select Group</label>
                        <Tooltip
                            content='Select No if you prefer a private vehicle.
Select Yes to share with a group on the same itinerary and save cost'
                            position='top'
                        >
                            <span className='eyeIcon'>
                                <InfoI color='blue' width={15} height={15} />
                            </span>
                        </Tooltip>
                    </div>
                    <select
                        value={customBooking?.customTrip?.isGroup}
                        name='isGroup'
                        onChange={(e) => {
                            const isTrue = e.target.value === 'true';

                            if (isTrue) {
                                setCustomBooking((prev) => ({
                                    ...prev,
                                    customTrip: {
                                        ...prev.customTrip,
                                        vehicleType: [
                                            { vehicleName: 'Two Wheeler', vehicleCount: 0 },
                                            { vehicleName: 'Two Wheeler - Premium', vehicleCount: 0 },
                                            { vehicleName: 'Car - 5 Seater', vehicleCount: 0 },
                                            { vehicleName: 'Car - 7 Seater', vehicleCount: 0 }
                                        ]
                                    }
                                }));
                            }

                            setCustomBooking((prev) => ({
                                ...prev,
                                customTrip: { ...prev.customTrip, isGroup: isTrue }
                            }));
                        }}
                        required={true}
                        className='dropRegSelect'
                        disabled={confirmedBookingData?.pickupLocation}
                    >
                        <option value='-1'>Select</option>
                        {isGroupOptions.map(function (val, typeIndex) {
                            return (
                                <option key={typeIndex} value={String(val.value)}>
                                    {val.label}
                                </option>
                            );
                        })}
                    </select>{' '}
                </>
            )}
            {customBooking?.customTrip?.isGroup === false && (
                <>
                    <div className='dropdownLabelText'>
                        <label className='dropdownlabel'>Select Vehicle</label>
                        <Tooltip content='Select a vehicle for your trip based on your requirements' position='top'>
                            <span className='eyeIcon'>
                                <InfoI color='blue' width={15} height={15} />
                            </span>
                        </Tooltip>
                    </div>
                    <VehicleSelector
                        label={vehicle?.length > 0 ? `Vehicles(${vehicle?.length})` : 'Select Vehicle'}
                        options={vehicleTypes}
                        setCustomBooking={setCustomBooking}
                        vehicleCounts={vehicleCounts}
                        setVehicleCounts={setVehicleCounts}
                    />{' '}
                </>
            )} */}
        </div>
    );
};
